import SEO from '@/components/feature/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import ExperienceSection from './components/ExperienceSection';
import FaqSection from './components/FaqSection';
import NewsletterSection from './components/NewsletterSection';
import { siteConfig } from '@/mocks/home';

const faqs = [
  {
    question: '爱风月是一个什么样的品牌？',
    answer: '爱风月是一个专注于风雅生活美学的文化品牌，致力于传播风月文化内涵、分享诗意浪漫生活方式。我们通过文章、活动和体验，让更多人感受到东方美学的独特魅力。',
  },
  {
    question: '爱风月的内容多久更新一次？',
    answer: '我们每周发布2-3篇原创文章，涵盖风雅生活、月下风流、情趣雅致、古风美学、诗意浪漫和文化神韵六大主题。订阅我们的通讯，第一时间获取最新内容。',
  },
  {
    question: '如何参加爱风月的线下体验活动？',
    answer: '我们的线下体验活动（茶道、香道、古乐聆赏、书法雅集等）会定期在北京举办。活动信息会提前通过通讯邮件和公众号发布。您也可以关注我们的社交媒体获取最新活动资讯。',
  },
  {
    question: '可以在爱风月投稿吗？',
    answer: '当然可以！我们非常欢迎热爱风月文化的作者投稿。请将您的稿件发送至 hello@aifengyue.com，我们会在7个工作日内回复。稿件主题需与风月文化、生活美学相关。',
  },
  {
    question: '爱风月的文章是否免费阅读？',
    answer: '目前爱风月的所有线上文章均为免费阅读。我们相信风月之美应该属于每一个人，因此我们坚持开放分享。如果您喜欢我们的内容，订阅通讯是最好的支持方式。',
  },
];

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteConfig.url}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
      email: 'hello@aifengyue.com',
      telephone: '010-8888-6666',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '南锣鼓巷风月胡同8号',
        addressLocality: '北京',
        addressRegion: '东城区',
        addressCountry: 'CN',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="爱风月 - 风雅情趣生活美学 | 诗意浪漫生活"
        description="爱风月，是一种对生活诗意与浪漫的深情追求。汇聚风月文化内涵、生活方式与美学体验，带你领略风月之间最真实的雅致与情韵。探索古风美学、月下风流与情趣雅致。"
        keywords="爱风月,风月情趣,风雅生活美学,诗意浪漫生活,月下风流,风月文化,情趣雅致,古风美学体验"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection />
        <PhilosophySection />
        <CategorySection />
        <ArticleSection />
        <ExperienceSection />
        <FaqSection />
        <NewsletterSection />
      </main>

      <Footer />
    </>
  );
}